import React, { useEffect, useState } from "react";
import styles from "./letGetStarted.module.css";
import { Row, Col, Button } from "react-bootstrap";
import Rocket from "../../../public/assets/rocket.svg";
import indiaflag from "../../../public/assets/inflag.svg";
import InputField from "../../../common/InputFieldWithDropDown/InputField";
import { generateDirectQuote } from "../../../api";
import { addCommasInPrice, decimalAdjust } from "../../../utils";
import { useNavigate } from "react-router";
import { useMyContext } from "../../../myContext";
import { defaultCurrency } from "../../../constant";

const LetGetStarted = () => {
  const [amount, setAmount] = useState("10000");
  const [currency, setCurrency] = useState(defaultCurrency);
  const [finalAmount, setFinalAmount] = useState("--");
  const navigate = useNavigate();
  const { themeColor, planId, partnerCode } = useMyContext();

  const generateQuoteApi = () => {
    const body = {
      amount: amount,
      fromCurrency: "INR",
      toCurrency: currency,
      inputCurrency: currency,
      panNo: "CVVPA1327A",
      planCd: planId,
      partnerCd: partnerCode,
    };
    try {
      generateDirectQuote(body).then((res) => {
        if (res?.data) {
          if (amount !== "") {
            const finalamount = decimalAdjust(
              "floor",
              res?.data?.finalFromAmount,
              -1
            );
            setFinalAmount(() => addCommasInPrice(finalamount));
          } else {
            setFinalAmount("--");
          }
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    let timeoutId;

    setFinalAmount("--");
    if (amount === "") {
      clearTimeout(timeoutId);
    }

    const generateQuoteWithDebounce = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        if (amount > 0) generateQuoteApi();
      }, 400);
    };

    generateQuoteWithDebounce();

    return () => {
      clearTimeout(timeoutId);
    };
  }, [amount, currency]);

  const inputAmount = (e) => {
    if (e.target.value !== "" && e.target.value === 0) setAmount(0);
    else if (e.target.value.length === 2 && e.target.value[0] == 0)
      setAmount(e.nativeEvent?.data);
    else if (e.target.value.length <= 7) setAmount(e.target.value);
  };

  return (
    <div className={styles.card}>
      <Row>
        <Col className="text-center">
          <img src={Rocket} className={styles.image} alt="" />
          <p className={styles.textStarted}>Let’s get started</p>
        </Col>
      </Row>
      <div className={styles.containerRow}>
        <div className={styles.inputFieldStarted}>
          <InputField
            label={"Recipient Gets"}
            conversionValueButton={defaultCurrency}
            value={amount}
            onChange={(e) => {
              inputAmount(e);
            }}
            dropdown={true}
            dropdownType={"HomeScreen"}
            setCurrency={setCurrency}
          />
        </div>
        <div className={styles.inputFieldStarted}>
          <InputField
            label={"You pay"}
            conversionValueButton={"INR"}
            disabled={true}
            value={finalAmount}
            inputSize="home"
            image={indiaflag}
          />
        </div>
        <Button
          className={styles.buttonSendNow}
          style={{ backgroundColor: themeColor, borderColor: themeColor }}
          onClick={() => navigate("/login")}
        >
          Send Now
        </Button>
      </div>
    </div>
  );
};

export default LetGetStarted;
